import axios from "axios"
import store from "../store/"

const charge = function (data) {
    return axios.post(`${store.state.api}/finance/student/omise/charge`, data)
}

const saveMyCard = function (tokenId) {
    return axios.post(`${store.state.api}/finance/student/omise/card`, { tokenId })
}

const listCards = function () {
    return axios.get(`${store.state.api}/finance/student/omise/cards`)
}

const deletecard = function (cardId) {
    return axios.delete(`${store.state.api}/finance/student/omise/card`, {
        cardId
    })
}

export const getOmisePublicKey = function () {
    return axios.get(`${store.state.api}/finance/student/omise/public-key`).then((resp) => {
        return resp.data
    })
}

export const createToken = function (card) {
    return new Promise((resolve, reject) => {
        let expires = card.expires.split("/");

        let tokenParameters = {
            expiration_month: +expires[0],
            expiration_year: +expires[1],
            name: card.holderName,
            number: card.cardNo,
            security_code: +card.secureCode,
        };

        Omise.createToken("card", tokenParameters, (statusCode, response) => {
            if (statusCode == 200) {
                // Success: send back the TOKEN_ID to your server to create a charge.
                // The TOKEN_ID can be found in `response.id`.
                resolve(response.id);
            } else {
                // Error: display an error message. Note that `response.message` contains
                // a preformatted error message. Also note that `response.code` will be
                // "invalid_card" in case of validation error on the card.

                // Example Error displaying
                reject(response);
            }
        })
    })
}

export default { charge, listCards, deletecard, saveMyCard, getOmisePublicKey }